
    <app-document-list
      [display]="display"
      [width]="width"
      [height]="height"
      [documents]="documentListItems"></app-document-list>
  